import axios from "axios";
import React, { useState, useEffect } from "react";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import Swal from 'sweetalert2';
import { baseUrl, userName, ipAddress } from './Univ.js';

function AddBooth() {

  const [constituencies, setConstituencies] = useState([]);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [boothData, setBoothData] = useState({
    constituency: '',
    booth_number: '',
    total_voters: '',
    male_voters: '',
    female_voters: '',
    new_voters: '',
    third_voters: '',
    status: '1',
    addedby: userName,
    ip_add: ipAddress
  });

  /* ---------------- HANDLE CHANGE ---------------- */
  const handleChange = (event) => {
    setBoothData({
      ...boothData,
      [event.target.name]: event.target.value
    });
  };

  /* ---------------- FORM SUBMIT ---------------- */
  const formSubmit = () => {
  // Validation
  if (!boothData.constituency || !boothData.booth_number) {
    Swal.fire('Error', 'Please fill all required fields', 'error');
    return;
  }

  // Create FormData
  const _formData = new FormData();
  _formData.append('constituency', boothData.constituency);
  _formData.append('booth_number', boothData.booth_number);
  _formData.append('total_voters', boothData.total_voters);
  _formData.append('male_voters', boothData.male_voters);
  _formData.append('female_voters', boothData.female_voters);
  _formData.append('new_voters', boothData.new_voters);
  _formData.append('third_voters', boothData.third_voters);
  _formData.append('status', boothData.status);
  _formData.append('addedby', userName);
  _formData.append('ip_add', ipAddress);

  // POST request
  axios.post(baseUrl + 'booths/', _formData, {
    headers: {
      'Content-Type': 'multipart/form-data',  // Note: must be multipart/form-data
    }
  })
  .then(response => {
    if (response.status === 200 || response.status === 201) {
      Swal.fire({
        title: 'Booth has been added',
        icon: 'success',
        timer: 3000,
        showConfirmButton: false
      });
        setTimeout(() => window.location.reload(), 1000);
      setBoothData({
        constituency: '',
        booth_number: '',
        total_voters: '',
        male_voters: '',
        female_voters: '',
        new_voters: '',
        third_voters: '',
        status: '1',
        addedby: userName,
        ip_add: ipAddress
      });
    }
  })
  .catch(error => {
    console.error(error.response?.data || error);
    Swal.fire('Error', 'Failed to add booth', 'error');
  });
};

  /* ---------------- FETCH BOOTHS ---------------- */
  const fetchData = () => {
    setIsLoading(true);
    axios.get(baseUrl + 'booths/')
      .then(response => {
        setRows(response.data);
        setIsLoading(false);
      })
      .catch(error => {
        console.log(error);
        setIsLoading(false);
      });
  };

  /* ---------------- FETCH CONSTITUENCIES ---------------- */
  const fetchConstituencies = () => {
    axios.get(baseUrl + 'constituencies/')
      .then(response => {
        setConstituencies(response.data);
      })
      .catch(error => console.log(error));
  };

  useEffect(() => {
    fetchData();
    fetchConstituencies();
  }, []);

    /* ---------------- DELETE ---------------- */
  const handleDelete = (id) => {
    Swal.fire({
      title: 'Confirm',
      text: 'Are you sure you want to delete this report?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Delete'
    }).then(result => {
      if (result.isConfirmed) {
        axios.delete(baseUrl + 'delete-booth/' + id + '/')
          .then(() => {
            Swal.fire('Deleted', 'Report deleted', 'success');
            setTimeout(() => window.location.reload(), 1000);
          });
      }
    });
  };

  /* ---------------- DATAGRID COLUMNS ---------------- */
  const columns = [
    { field: 'id', headerName: 'ID', width: 80 },
  {
      field: 'constituency',
      headerName: 'constituency',
      width: 200,
      renderCell: (params) => {
        if (params && params.row && params.row.constituency) {
          if (params.row.constituency !== null && params.row.constituency.name !== 0) {
            return params.row.constituency?.name;
          }
        }
        return 'Unknown';
      },
    },
    { field: 'booth_number', headerName: 'Booth Number', width: 150 },
    { field: 'total_voters', headerName: 'Total Voters', width: 150 },
    { field: 'male_voters', headerName: 'Male Voters', width: 150 },
    { field: 'female_voters', headerName: 'Female Voters', width: 150 },
    { field: 'addedby', headerName: 'Added By', width: 150 },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 150,
      renderCell: (params) => (
        <button className="btn btn-danger btn-sm" onClick={() => handleDelete(params.row.id)}>Delete</button>
      )
    }
  ];

  return (
    <section className="container mt-4">

      <div className="row">
        <div className="col-md-9 col-12 mb-2">
          <div className="card">
            <h4 className="card-header">Add Booth</h4>
            <div className="card-body">

              <form>
                <div className="mb-3">
                  <label className="form-label">Constituency</label>
                  <select
                    className="form-control"
                    name="constituency"
                    value={boothData.constituency}
                    onChange={handleChange}
                  >
                    <option value="">-- Select Constituency --</option>
                    {constituencies.map((c) => (
                      <option key={c.id} value={c.id}>{c.name}</option>
                    ))}
                  </select>
                </div>

                <div className="mb-3">
                  <label className="form-label">Booth Number</label>
                  <input
                    type="text"
                    className="form-control"
                    name="booth_number"
                    value={boothData.booth_number}
                    onChange={handleChange}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Total Voters</label>
                  <input
                    type="number"
                    className="form-control"
                    name="total_voters"
                    value={boothData.total_voters}
                    onChange={handleChange}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Male Voters</label>
                  <input
                    type="number"
                    className="form-control"
                    name="male_voters"
                    value={boothData.male_voters}
                    onChange={handleChange}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Female Voters</label>
                  <input
                    type="number"
                    className="form-control"
                    name="female_voters"
                    value={boothData.female_voters}
                    onChange={handleChange}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">New Voters</label>
                  <input
                    type="number"
                    className="form-control"
                    name="new_voters"
                    value={boothData.new_voters}
                    onChange={handleChange}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Third Voters</label>
                  <input
                    type="number"
                    className="form-control"
                    name="third_voters"
                    value={boothData.third_voters}
                    onChange={handleChange}
                  />
                </div>

                <button
                  type="button"
                  onClick={formSubmit}
                  className="btn btn-primary"
                >
                  Submit
                </button>
              </form>

            </div>
          </div>
        </div>
      </div>

<div style={{ width: '100%' }}>
        <DataGrid
          className="mt-4"
          rows={rows}
          columns={columns}
          loading={isLoading}
          pageSize={25}
          rowsPerPageOptions={[25, 50, 100]}
          components={{ Toolbar: GridToolbar }}
          autoHeight
          sx={{
            boxShadow: 4,
            border: 4,
            borderColor: 'primary.light',
            '& .MuiDataGrid-cell:hover': {
              color: 'primary.main'
            }
          }}
        />
      </div>

    </section>
  );
}

export default AddBooth;
